import mdlProduct from '@/models/Warehouse/WhProduct'
import {
    generateFetchDataFunction,
    generateDeleteItemFunction,
} from './DataTableService'

const includes = ['sl_wholesale_discounts']
const appends = ['sale_prices', 'stocks']

const dtFetchData = generateFetchDataFunction(mdlProduct,includes,appends)
const dtDeleteItem = generateDeleteItemFunction(mdlProduct)
// If we need a custom route for the show and edit view:
// const showEditRoute = 'custom_route'

export default {
    dtFetchData,
    dtDeleteItem,
    //showEditRoute
}
